// extracted by mini-css-extract-plugin
export var container = "_cf-0";
export var popoverContent = "_cf-1";
export var tosLink = "_cf-2";